import "../foundation-datepicker";

import AmcFundChartBase from "../amc-fund-chart-base";

class WebsiteChartBase extends AmcFundChartBase {
    constructor(containerId, fundCode) {
        super(containerId, fundCode);
    }

    getRangeSelectors() {
        this.$rangeSelectors = $(`#${this.containerId}`).siblings(".fil-highcharts-range-selectors");
    }

    bindEvents() {
        super.bindEvents();
        this.getRangeSelectors();
        this.$rangeSelectors.find(".fil-highcharts-range-buttons .fil-switch__item input").on("change", (e) => {
            const index = $(e.target).attr("selector-index");
            const rangeSelectors = this.chart.rangeSelector;
            const rangeButtonOption = rangeSelectors.buttonOptions[index];
            this.updateExtremes(rangeButtonOption, index);
            this.updateRangeButtonPosition(index);
        });
    }

    updateExtremes(rangeButtonOption, index) {
        super.updateExtremes(rangeButtonOption);
        this.updateRangeButtonStatus(index);
    }

    updateRangeButtonStatus(checkedIndex = null) {
        if (checkedIndex != null) {
            this.$rangeSelectors.find(".fil-highcharts-range-buttons .fil-switch__item input").prop("checked", false);
            this.$rangeSelectors
                .find(".fil-highcharts-range-buttons .fil-switch__item input")
                .eq(checkedIndex)
                .prop("checked", true);
            return;
        }

        const rangeButtons = this.chart.rangeSelector.buttonOptions;
        let min = this.chart.xAxis[0].min;
        let max = this.chart.xAxis[0].max;
        let dataMin = this.time_start.date.getTime();
        min = new Date(min).toISOString().slice(0, 10);
        max = new Date(max).toISOString().slice(0, 10);

        if (max != this.endFundDate.toISOString().slice(0, 10)) {
            this.$rangeSelectors.find(".fil-highcharts-range-buttons .fil-switch__item input").prop("checked", false);
            return;
        }
        for (let index in rangeButtons) {
            let item = rangeButtons[index];
            let isEnable = item.startDate >= this.startFundDate.getTime();
            let isActive = item.startDate == dataMin;
            let buttonItem = this.$rangeSelectors.find(".fil-highcharts-range-buttons .fil-switch__item input")[index];
            if (isActive) {
                $(buttonItem).prop("checked", true);
            } else {
                $(buttonItem).prop("checked", false);
            }
        }
    }

    updateRangeButtonPosition(index) {
        let item = this.$rangeSelectors.find(".fil-highcharts-range-buttons .fil-switch__item")[index];
        let offsetLeft = item.getBoundingClientRect().left;
        let scrollLength = offsetLeft - (window.innerWidth - item.offsetWidth) / 2;

        this.scrollByPixels(this.$rangeSelectors.find(".fil-highcharts-range-buttons .fil-switch"), scrollLength);
    }

    datepickerInit(category, start_date, end_date) {
        this.startDateCalender = new Date(start_date);
        this.endDateCalender = new Date(end_date);
        this.time_start = $(`#${category}-datetime-start`)
            .fdatepicker({
                initialDate: start_date,
                startDate: start_date,
                endDate: end_date,
                disableDblClickSelection: true,
                language: "zh-CN",
                format: "yyyy-mm-dd",
            })
            .on("changeDate", (ev) => {
                if (ev.date.valueOf() < this.endDateCalender.valueOf()) {
                    let seriesIndex = this.chart.series[0].points ? 0 : 1;
                    if (
                        this.chart.series[seriesIndex].points.length <= 5 &&
                        this.chart.xAxis[0].dataMin < new Date(ev.date)
                    ) {
                        this.time_start.update(new Date(this.chart.xAxis[0].dataMin));
                    } else {
                        if (this.chart) {
                            this.chart.xAxis[0].setExtremes(
                                new Date(ev.date).getTime(),
                                new Date($(`#${category}-datetime-end`).val()).getTime(),
                            );
                        }
                    }
                } else {
                    this.time_start.update(this.startDateCalender);
                }
                this.time_start.hide();
            })
            .data("datepicker");

        this.time_end = $(`#${category}-datetime-end`)
            .fdatepicker({
                initialDate: end_date,
                startDate: start_date,
                endDate: end_date,
                disableDblClickSelection: true,
                language: "zh-CN",
                format: "yyyy-mm-dd",
            })
            .on("changeDate", (ev) => {
                if (ev.date.valueOf() > this.startDateCalender.valueOf()) {
                    let seriesIndex = this.chart.series[0].points ? 0 : 1;

                    if (
                        this.chart.series[seriesIndex].points.length <= 5 &&
                        this.chart.xAxis[0].dataMax > new Date(ev.date)
                    ) {
                        this.time_end.update(new Date(this.chart.xAxis[0].dataMax));
                    } else {
                        if (this.chart) {
                            this.chart.xAxis[0].setExtremes(
                                new Date($(`#${category}-datetime-start`).val()).getTime(),
                                new Date(ev.date).getTime(),
                            );
                        }
                    }
                } else {
                    this.time_end.update(this.endDateCalender);
                }
                this.time_end.hide();
            })
            .data("datepicker");
    }

    datepickerUpdate(min_date, max_date) {
        this.startDateCalender = new Date(min_date);
        this.endDateCalender = new Date(max_date);
        this.time_start.update(this.startDateCalender);
        this.time_end.update(this.endDateCalender);
    }

    initRangeButton(options) {
        let buttonOptions = options.rangeSelector.buttons;
        for (let index in buttonOptions) {
            let { minDate, maxDate } = this.getExtremesMinAndMaxDate(buttonOptions[index]);
            let buttonItem = this.$rangeSelectors.find(".fil-highcharts-range-buttons .fil-switch__item input")[index];
            buttonOptions[index]["startDate"] = minDate;
            buttonOptions[index].endDate = maxDate;
            $(buttonItem).attr("selector-index", index);
            let isEnable = minDate >= this.startFundDate.getTime();
            if (isEnable) {
                $(buttonItem).prop("disabled", false);
            } else {
                $(buttonItem).prop("disabled", true);
            }
        }
    }

    legendItemClickEvent(e) {
        e.preventDefault();
        e.target.setVisible(!e.target.visible);

        this.chart.series.some((series) => {
            if (!series.options.isInternal && series.visible === true) {
                this.$rangeSelectors.find("input").prop("disabled", false);
                this.initRangeButton(options);
                this.updateRangeButtonStatus();
                return true;
            }

            this.$rangeSelectors.find("input").prop({ disabled: true, checked: false });
        });
    }
}

export default WebsiteChartBase;
